import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'LhcManage/LhcUrl/index',
    method: 'get',
    params: params
  })
}




/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'LhcManage/LhcUrl/del',
    method: 'get',
    params: {
      id: id
    }
  })
}


/**
* 锁定/解锁
*/
export const lock = (id) => {
return axios.request({
url: 'LhcManage/LhcUrl/lock',
method: 'get',
params: {
id: id
}
})
}

/**
* 获取列表
* @returns {wx.RequestTask | never}
*/
export const caijiSuper = () => {
return axios.request({
url: 'LhcManage/LhcUrl/caijiSuper',
method: 'get'
})
}

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const makeSuper = () => {
  return axios.request({
    url: 'LhcManage/LhcUrl/makeSuper',
    method: 'get'
  })
}

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getZip = () => {
  return axios.request({
    url: 'LhcManage/LhcUrl/getZip',
    method: 'get'
  })
}


/**
 * 锁定/解锁
 */
export const isAuto = (id) => {
  return axios.request({
    url: 'LhcManage/LhcUrl/isAuto',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 锁定/解锁
 */
export const isAutoChangeErrorBbs = (id) => {
  return axios.request({
    url: 'LhcManage/LhcUrl/isAutoChangeErrorBbs',
    method: 'get',
    params: {
      id: id
    }
  })
}


/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const changeErrorBbs = () => {
  return axios.request({
    url: 'LhcManage/LhcUrl/changeErrorBbs',
    method: 'get'
  })
}



/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'LhcManage/LhcUrl/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'LhcManage/LhcUrl/add',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'LhcManage/LhcUrl/edit',
    method: 'post',
    data
  })
}
